import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGaugeHigh, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import myLogo from '../../LOGO.png';
import connectLogo from '../../primedha connect.png';

// The parts every WhatsApp page shares - the side-panel layout and the WhatsApp dashboard (/wadashboard) both use them.

/** The Primedha Connect logo on its own, in the extreme top left corner of the window - above the side panel, not in it. */
export const WaCornerLogo = () => (
  <img src={connectLogo} alt="Primedha Connect" className="page-corner-logo" />
);

/**
 * Top-right bar, left to right: the signed-in user's own read-only profile, Logout, and Dashboard in the corner. A locked-out profile
 * keeps its Logout (so it is not stranded) but not the way back to the WhatsApp dashboard (/wadashboard), which Dashboard opens.
 */
export const WaTopBar = ({ locked }) => {
  const navigate = useNavigate();
  const currentPath = useLocation().pathname;

  const handleLogout = (e) => {
    e.preventDefault();
    // Create a hidden form to perform a POST logout
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${process.env.REACT_APP_NOTIFICATION_SERVICE_APIGW_ENDPOINT}/logout`;
    document.body.appendChild(form);
    form.submit();
  };

  return (
    <div className="content-topbar">
      <Link to="/whatsapp/my-profile"
        className={`my-profile-link ${currentPath === '/whatsapp/my-profile' ? 'active' : ''}`}>
        My User Profile
      </Link>
      <button type="button" onClick={handleLogout} className="topbar-button logout-button">
        <FontAwesomeIcon icon={faRightFromBracket} className="nav-button-icon" />Logout
      </button>
      {!locked && (
        <button type="button" onClick={() => navigate('/wadashboard')} className="topbar-button back-to-dashboard-button">
          <FontAwesomeIcon icon={faGaugeHigh} className="nav-button-icon" />Dashboard
        </button>
      )}
    </div>
  );
};

/** The company footer: the PRIMEDHA logo, the product line and the copyright line. */
export const WaFooter = () => (
  <footer className="company-footer">
    <img src={myLogo} alt="Logo" className="footer-logo" />

    <div className="footer-info">
      <p className="copyright-text">
        &copy; Primedha Connect a product of Primedha Technologies
      </p>
      <p className="copyright-text">
        &copy; {new Date().getFullYear()} PRIMEDHA Technologies Pvt Ltd. All rights reserved.
      </p>
    </div>
  </footer>
);
